module.exports = __webpack_public_path__ + "img/documents--icon.5702173c.svg";